import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import DataConnector from 'connect/DataConnector';

import CoreModelHubView, {type CoreModelHubRoute} from './CoreModelHubView';
import type {ModelHubRoute} from './modelHubRoutes';
import ModelHubRouteStore from './ModelHubRouteStore';
import {ScientificModelsView} from './scientific-models/ScientificModelsView';

interface ModelHubScreenEnhancedProps {
  currentRoute: ModelHubRoute | null;
}

class ModelHubScreenConnector extends DataConnector<{}, ModelHubScreenEnhancedProps> {
  override shouldSubscribeToRedux = false;
  override stores = [ModelHubRouteStore];

  enhanceProps(): ModelHubScreenEnhancedProps {
    return {currentRoute: ModelHubRouteStore.getCurrentRoute()};
  }
}

// `account` and `signup` are standalone-only and keep falling through to the legacy view.
function isCoreModelHubRoute(route: ModelHubRoute): route is CoreModelHubRoute {
  return (
    route.kind === 'models' ||
    route.kind === 'predictions' ||
    route.kind === 'batches' ||
    route.kind === 'new-prediction' ||
    route.kind === 'prediction-detail' ||
    route.kind === 'batch-detail'
  );
}

function ModelHubScreen({currentRoute}: ModelHubScreenEnhancedProps): JSX.Element {
  if (
    BenchlingConfig.MODEL_HUB_ENABLE_REDESIGNED_UI &&
    currentRoute != null &&
    isCoreModelHubRoute(currentRoute)
  ) {
    return <CoreModelHubView route={currentRoute} />;
  }
  return <ScientificModelsView />;
}

export default ModelHubScreenConnector.connect(ModelHubScreen);
